import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import IssuedChequeDetailView from 'src/sections/issued-cheque/view/issued-cheque-detail-view';

export default function IssuedChequeDetailPage() {
  const { user: authUser } = useAuthContext();

  const { id } = useParams();

  return (
    <>
      <Helmet>
        <title> Issued Cheque Details</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_ISSUED_CHEQUE,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <IssuedChequeDetailView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
